module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/015-el-salvador-fa68f326d6b34f15214e2980acd5b98c.svg";